<!--
  购物车
  lovi 2020-06-24
-->
<template>
  <div class="item-wrap">
    <van-stepper
      v-model="data.count"
      theme="round"
      button-size="22"
      :min="0"
      :max="data.stock"
      :input-width="data.count == 0 ? '0' : '28'"
      disable-input
      :show-minus="data.count ? true : false"
      async-change
      @plus="clickStepper"
      @minus="clickStepper"
    />
    <!-- 
      @change="stepperChange"
      @plus="clickPlus"
      @minus="clickMinus"
     -->
    <div
      class="item"
      @click="
        _linkFun('/commodity?shopId=' + shopId + '&proId=' + data.product_id)
      "
    >
      <div class="image">
        <img :src="httpUrl + data.product_img" />
      </div>
      <div class="info">
        <h3>{{ data.product_name }}</h3>
        <p class="">
          <span class="text-gray">
            {{ $t("life.monthSold") }}
            {{ data.month_sales }}
          </span>
        </p>
        <div class="price-wrap">
          <div class="price">
            <span class="text-red">{{ data.selling_price }}P</span>
            <span v-if="data.original_price" class="original_price text-gray">
              {{ data.original_price }}P
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"],
  components: {},
  data() {
    return {
      shopId: ""
    };
  },
  created() {
    this.shopId = this.$route.query.shopId;
  },
  mounted() {},
  computed: {},
  methods: {
    clickStepper() {
      let obj = this.data;
      obj.shopId = this.shopId;
      console.log("clickStepper", obj);
      this.$store.dispatch("SET_SHOPCART_DATA", obj);
    },
    stepperChange(value) {
      // 操作步进器
      let obj = this.data;
      obj.shopId = this.shopId;
      console.log("stepperChange", value, obj);
      this.$store.dispatch("SET_SHOPCART_DATA", obj);
    }
  },
  watch: {}
  // beforeDestroy: {}
};
</script>

<style lang="less" scoped>
.item-wrap {
  padding: 5px 10px;
  position: relative;
  /deep/.van-stepper {
    position: absolute;
    bottom: 5px;
    right: 10px;
    .van-stepper__minus {
      color: #1a83ff;
      border-color: #1a83ff;
    }
    .van-stepper__plus {
      background: #1a83ff;
    }
  }
}
.item {
  display: flex;
  justify-content: flex-start;
  .image {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    width: 60px;
    height: 60px;
    border-radius: 4px;
    overflow: hidden;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .info {
    flex: 1;
    line-height: 1;
    font-size: 10px;
    h3 {
      font-size: 14px;
      font-weight: 400;
    }
    p {
      margin-top: 5px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 16px;
      line-height: 1;
      span {
        margin-right: 5px;
        display: flex;
        align-items: center;
      }
    }
    .price-wrap {
      margin-top: 5px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .price {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        span {
          &.text-red {
            font-size: 15px;
          }
          &.original_price {
            margin-left: 5px;
            text-decoration: line-through;
          }
        }
      }
    }
  }
}
</style>
